import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Badge, DataTable, EmptyState } from "@/components/DataTable";
import { PageHead } from "@/components/Filters";
import { api, errMsg, inr } from "@/lib/api";

export default function Watchlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/watchlist");
      setItems(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    await api.delete(`/watchlist/${id}`);
    setItems((p) => p.filter((i) => i.id !== id));
    toast.success("Removed from watchlist");
  };

  const columns = [
    {
      key: "college",
      label: "College",
      minWidth: 360,
      render: (r) => (
        <span className="block max-w-[460px] whitespace-normal" title={r.college}>
          {r.college}
        </span>
      ),
    },
    { key: "branch", label: "Branch", minWidth: 170, render: (r) => r.branch || <span className="text-slate-400">Any</span> },
    { key: "quota", label: "Quota", width: 130, render: (r) => (r.quota ? <Badge tone="blue" width="quota">{r.quota}</Badge> : <span className="text-slate-400">NA</span>) },
    {
      key: "closing_rank",
      label: "Last closing rank",
      align: "right",
      width: 160,
      highlight: true,
      render: (r) => (r.closing_rank ? Number(r.closing_rank).toLocaleString("en-IN") : "—"),
    },
    { key: "total_fee", label: "Total fee", align: "right", width: 130, mono: true, render: (r) => inr(r.total_fee) },
  ];

  return (
    <div className="space-y-4" data-testid="watchlist-page">
      <PageHead title="Watchlist" subtitle="Your shortlisted college and branch combinations with the latest published numbers." />
      {loading ? (
        <div className="border border-slate-200 bg-white p-10 text-center text-sm text-slate-400">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState testId="watchlist-empty" title="Watchlist is empty" hint="Click “Watch” on any allotment or closing-rank row to shortlist it." />
      ) : (
        <DataTable
          testId="watchlist-table"
          columns={columns}
          rows={items}
          rowKey={(r) => r.id}
          rowActions={(r) => (
            <button data-testid={`remove-watch-${r.id}`} onClick={() => remove(r.id)} className="text-slate-400 hover:text-rose-600">
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          )}
        />
      )}
    </div>
  );
}
